"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[212],{

/***/ 87082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* binding */ Content; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/components/content/stitches.ts
var stitches = __webpack_require__(65465);
;// CONCATENATED MODULE: ./src/components/content/preview.tsx




function Preview(param) {
    var children = param.children, _isHighlighted = param.isHighlighted, isHighlighted = _isHighlighted === void 0 ? false : _isHighlighted;
    var ref = (0,react.useRef)();
    // @TODO: we may implement this post-MVP as we make the previewer and editor more integrated
    // const { sendParentMessage } = useWindowMessaging(contentGetCmsUrl(), [id]);
    (0,react.useEffect)(function() {
        if (isHighlighted && ref.current) {
            ref.current.scrollIntoView({
                behavior: "smooth",
                block: "center"
            });
        }
    }, [
        isHighlighted
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        // @ts-expect-error
        ref: ref,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Contents, {
                children: children
            }),
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay, {
                isHighlighted: isHighlighted
            })
        ]
    });
}
var Overlay = (0,stitches/* styled */.zo)("button", {
    backgroundColor: "rgba(13,108,242,.3)",
    border: "3px solid #0D6CF2",
    cursor: "pointer",
    position: "absolute",
    opacity: 0,
    inset: 0,
    transition: "all .1s ease",
    zIndex: "$20",
    variants: {
        isHighlighted: {
            true: {
                opacity: 1
            }
        }
    }
});
var Container = (0,stitches/* styled */.zo)("div", (0,_define_property/* default */.Z)({
    position: "relative"
}, "&:hover ".concat(Overlay), {
    opacity: 1
}));
var Contents = (0,stitches/* styled */.zo)("div", {
    pointerEvents: "none"
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/polished/dist/polished.esm.js + 3 modules
var polished_esm = __webpack_require__(8782);
// EXTERNAL MODULE: ./src/redux/cmsConfig/index.ts
var cmsConfig = __webpack_require__(26738);
// EXTERNAL MODULE: ./src/redux/cmsConfig/utils.ts
var utils = __webpack_require__(73393);
// EXTERNAL MODULE: ./src/utils/safePolished.ts
var safePolished = __webpack_require__(68902);
;// CONCATENATED MODULE: ./src/components/content/fields/button/button.tsx









function Button(param) {
    var _style = param.style, style = _style === void 0 ? "primary" : _style, _href = param.href, href = _href === void 0 ? "#" : _href, label = param.label, _newWindow = param.newWindow, newWindow = _newWindow === void 0 ? false : _newWindow, _type = param.type, type = _type === void 0 ? "local" : _type;
    var getButtonTheme = function getButtonTheme(value) {
        var values = (0,_object_spread/* default */.Z)({
            height: "".concat(field_height, "px")
        }, (0,utils/* getFontStyles */.l)(font, [
            "font_size"
        ]));
        switch(value){
            case "primary":
                values = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, values), {
                    background: primary_button_background_color,
                    borderRadius: "".concat(primary_button_border_radius, "px"),
                    border: "1px solid ".concat(primary_button_border_color)
                }), (0,utils/* getFontStyles */.l)(primary_font, [
                    "color",
                    "font_family",
                    "font_style",
                    "line_height"
                ], {
                    color: function(value) {
                        return value !== null && value !== void 0 ? value : (0,safePolished/* safePolished */.F)(polished_esm/* readableColor */.XV)(primary_button_background_color);
                    }
                })), {
                    "&:hover": {
                        background: primary_button_background_hover_color,
                        borderColor: primary_button_border_hover_color,
                        color: primary_button_text_hover_color
                    }
                });
                break;
            case "secondary":
                values = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, values), {
                    background: secondary_button_background_color,
                    borderRadius: "".concat(secondary_button_border_radius, "px"),
                    border: "1px solid ".concat(secondary_button_border_color)
                }), (0,utils/* getFontStyles */.l)(secondary_font, [
                    "color",
                    "font_family",
                    "font_style",
                    "line_height"
                ], {
                    color: function(value) {
                        return value !== null && value !== void 0 ? value : (0,safePolished/* safePolished */.F)(polished_esm/* readableColor */.XV)(secondary_button_background_color);
                    }
                })), {
                    "&:hover": {
                        background: secondary_button_background_hover_color,
                        borderColor: secondary_button_border_hover_color,
                        color: secondary_button_text_hover_color
                    }
                });
                break;
            case "tertiary":
                values = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, values), {
                    background: knockout_button_background_color,
                    borderRadius: "".concat(knockout_button_border_radius, "px"),
                    border: "1px solid ".concat(knockout_button_border_color)
                }), (0,utils/* getFontStyles */.l)(knockout_font, [
                    "color",
                    "font_family",
                    "font_style",
                    "line_height"
                ], {
                    color: function(value) {
                        return value !== null && value !== void 0 ? value : knockout_button_border_color;
                    }
                })), {
                    "&:hover": {
                        background: knockout_button_background_hover_color,
                        borderColor: knockout_button_border_hover_color,
                        color: knockout_button_text_hover_color
                    }
                });
                break;
            default:
                break;
        }
        return values;
    };
    var ref = (0,cmsConfig/* useConfigOverride */.$E)("buttons"), primary_font = ref.primary_font, secondary_font = ref.secondary_font, knockout_font = ref.knockout_font, primary_button_background_color = ref.primary_button_background_color, primary_button_border_radius = ref.primary_button_border_radius, primary_button_border_color = ref.primary_button_border_color, primary_button_background_hover_color = ref.primary_button_background_hover_color, primary_button_border_hover_color = ref.primary_button_border_hover_color, primary_button_text_hover_color = ref.primary_button_text_hover_color, secondary_button_background_color = ref.secondary_button_background_color, secondary_button_border_radius = ref.secondary_button_border_radius, secondary_button_border_color = ref.secondary_button_border_color, secondary_button_background_hover_color = ref.secondary_button_background_hover_color, secondary_button_border_hover_color = ref.secondary_button_border_hover_color, secondary_button_text_hover_color = ref.secondary_button_text_hover_color, knockout_button_background_color = ref.knockout_button_background_color, knockout_button_border_radius = ref.knockout_button_border_radius, knockout_button_border_color = ref.knockout_button_border_color, knockout_button_background_hover_color = ref.knockout_button_background_hover_color, knockout_button_border_hover_color = ref.knockout_button_border_hover_color, knockout_button_text_hover_color = ref.knockout_button_text_hover_color;
    var ref1 = (0,cmsConfig/* useConfigOverride */.$E)("forms"), field_height = ref1.field_height, font = ref1.font;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: type === "local" ? "/".concat(href) : href,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Element, {
            "data-css-override": "StyledPrimaryButton",
            target: newWindow || type !== "local" ? "_blank" : "_self",
            css: getButtonTheme(style),
            children: label
        })
    });
}
var Element = (0,stitches/* styled */.zo)("a", {
    alignItems: "center",
    display: "flex",
    fontWeight: "normal",
    justifyContent: "center",
    lineHeight: "normal",
    minWidth: "100px",
    overflow: "hidden",
    padding: "0 $5",
    position: "relative",
    textAlign: "center",
    textDecoration: "none",
    transition: "all .15s ease"
});

;// CONCATENATED MODULE: ./src/components/content/modules/button.tsx


function button_Button(param) {
    var _style = param.style, style = _style === void 0 ? "primary" : _style, url = param.url;
    var reference = url.reference, label = url.label;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
        style: style,
        href: reference === null || reference === void 0 ? void 0 : reference.url,
        newWindow: reference === null || reference === void 0 ? void 0 : reference.newWindow,
        label: label,
        type: reference === null || reference === void 0 ? void 0 : reference.type
    });
}

// EXTERNAL MODULE: ./src/utils/imageHelper.ts
var imageHelper = __webpack_require__(70595);
;// CONCATENATED MODULE: ./src/components/content/modules/image.tsx



function Image(param) {
    var image = param.image, url = param.url;
    var reference = url.reference, label = url.label;
    var imageComponent = /*#__PURE__*/ (0,jsx_runtime.jsx)(image_Element, {
        src: (0,imageHelper/* resizeImage */.tg)(image === null || image === void 0 ? void 0 : image.url, {
            width: 1500
        }),
        alt: image === null || image === void 0 ? void 0 : image.title
    });
    if (reference === null || reference === void 0 ? void 0 : reference.url) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: reference.url,
            title: label,
            children: imageComponent
        });
    }
    return imageComponent;
}
var image_Element = (0,stitches/* styled */.zo)("img", {
    height: "auto",
    maxHeight: "500px",
    objectFit: "cover",
    width: "100%"
});

;// CONCATENATED MODULE: ./src/components/content/fields/richtext/types.ts
var Elements;
(function(Elements) {
    Elements[// @TODO: update brand cms type to blockItem. This is a generic that can be displayed as a <p> or <h2> tag
    "inline"] = "text";
    Elements["blockItem"] = "paragraph";
    Elements["orderedList"] = "ol";
    Elements["unorderedList"] = "ul";
    Elements["paragraph"] = "p";
    Elements["heading"] = "h2";
    Elements["subheading"] = "h3";
    Elements["listItem"] = "li";
    Elements["anchor"] = "a";
})(Elements || (Elements = {}));

;// CONCATENATED MODULE: ./src/components/content/fields/richtext/elements.tsx



/*
 *
 * Maps an element size to a tag. This allows us to generate a better document markup
 * for content. However, in the future, tags should be controlled independently of size
 */ function getTagFromSize() {
    var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "normal";
    switch(size){
        case "small":
            return "p";
        case "normal":
            return "p";
        case "large":
            return "h3";
        case "x-large":
            return "h2";
    }
}
/*
 *
 * Outputs the raw, inline text for every element.
 * This can be a link, span, paragraph, or heading
 */ function getFormattedText(props, index) {
    if (props.type === Elements.anchor) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor, {
            href: props.href,
            target: props.target,
            children: props.children.map(function(item, index) {
                return getFormattedText(item, index);
            })
        }, index);
    } else {
        var _bold = props.bold, bold = _bold === void 0 ? false : _bold, _italic = props.italic, italic = _italic === void 0 ? false : _italic, _size = props.size, size = _size === void 0 ? "normal" : _size, _color = props.color, color = _color === void 0 ? undefined : _color, text = props.text;
        if (text === "") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}, index);
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormattedText, {
            bold: bold,
            italic: italic,
            fontSize: size,
            css: {
                color: color !== null && color !== void 0 ? color : "inherit"
            },
            children: text
        }, index);
    }
}
/*
 *
 * Outputs block elements like <ul>, <ol>, and <li>
 * Passes through other elements like <h2> and <p> that are less structured.
 */ function formatRichText(param, index) {
    var type = param.type, children = param.children;
    switch(type){
        case Elements.blockItem:
            var firstChild = children[0];
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormattedText, {
                as: firstChild.type === Elements.anchor ? "div" : getTagFromSize(firstChild.size),
                children: children.map(function(item, index) {
                    return getFormattedText(item, index);
                })
            });
        case Elements.listItem:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Li, {
                children: children.map(function(item, index) {
                    return getFormattedText(item, index);
                })
            }, index);
        case Elements.unorderedList:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: children.map(function(value, index) {
                    return formatRichText(value, index);
                })
            }, index);
        case Elements.orderedList:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                children: children.map(function(value, index) {
                    return formatRichText(value, index);
                })
            }, index);
        default:
            console.warn("unsupported element: ".concat(type));
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
}
var FormattedText = (0,stitches/* styled */.zo)("span", {
    margin: 0,
    variants: {
        bold: {
            true: {
                fontFamily: "$primaryBold",
                fontWeight: "bold"
            }
        },
        italic: {
            true: {
                fontStyle: "italic"
            }
        },
        fontSize: {
            small: {
                fontFamily: "$primary",
                fontSize: "$text200",
                "@md": {
                    fontSize: "$text300"
                }
            },
            normal: {
                fontFamily: "$primary",
                fontSize: "$text300",
                "@md": {
                    fontSize: "$text400"
                }
            },
            large: {
                fontFamily: "$secondary",
                fontSize: "$text500",
                lineHeight: "$tighter",
                "@md": {
                    fontSize: "$text600"
                }
            },
            "x-large": {
                fontFamily: "$secondary",
                fontSize: "$text700",
                lineHeight: "$tighter",
                "@maxsm": {
                    fontSize: "$text600"
                },
                "@md": {
                    fontSize: "$text800"
                }
            }
        }
    },
    compoundVariants: [
        {
            bold: false,
            fontSize: "small",
            css: {
                fontFamily: "$primary"
            }
        },
        {
            bold: true,
            fontSize: "small",
            css: {
                fontFamily: "$primaryBold"
            }
        },
        {
            bold: false,
            fontSize: "medium",
            css: {
                fontFamily: "$primary"
            }
        },
        {
            bold: true,
            fontSize: "medium",
            css: {
                fontFamily: "$primaryBold"
            }
        },
        {
            bold: false,
            fontSize: "large",
            css: {
                fontFamily: "$secondary"
            }
        },
        {
            bold: true,
            fontSize: "large",
            css: {
                fontFamily: "$secondaryBold"
            }
        },
        {
            bold: false,
            fontSize: "x-large",
            css: {
                fontFamily: "$secondary"
            }
        },
        {
            bold: true,
            fontSize: "x-large",
            css: {
                fontFamily: "$secondaryBold"
            }
        }, 
    ]
});
var Li = (0,stitches/* styled */.zo)("li", {
    listStylePosition: "inside"
});
var Anchor = (0,stitches/* styled */.zo)("a", {
    span: {
        textDecoration: "underline"
    }
});

;// CONCATENATED MODULE: ./src/components/content/fields/richtext/richtext.tsx



function RichText(param) {
    var value = param.value;
    var parsedValue = JSON.parse(value !== "" ? value : "[]");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(richtext_Container, {
        children: parsedValue.map(function(item, index) {
            return formatRichText(item, index);
        })
    });
}
var richtext_Container = (0,stitches/* styled */.zo)("div", {
    margin: 0,
    maxWidth: "$2xl"
});

;// CONCATENATED MODULE: ./src/components/content/modules/text.tsx


function Text(param) {
    var body = param.body;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText, {
        value: body
    });
}

;// CONCATENATED MODULE: ./src/components/content/modules/types.ts
var Modules;
(function(Modules) {
    Modules["button"] = "button";
    Modules["column"] = "column";
    Modules["columns"] = "columns";
    Modules["container"] = "container";
    Modules["form"] = "form";
    Modules["formEmail"] = "formEmail";
    Modules["formLocations"] = "formLocations";
    Modules["formMessage"] = "formMessage";
    Modules["formPhone"] = "formPhone";
    Modules["formText"] = "formText";
    Modules["hero"] = "hero";
    Modules["iframe"] = "iframe";
    Modules["image"] = "image";
    Modules["link"] = "link";
    Modules["linkList"] = "linkList";
    Modules["popularItems"] = "popularItems";
    Modules["slide"] = "slide";
    Modules["slider"] = "slider";
    Modules["text"] = "text";
})(Modules || (Modules = {}));

;// CONCATENATED MODULE: ./src/components/content/fields/alignment/utils.ts
function getAlignmentVariants() {
    return [
        {
            direction: "vertical",
            alignment: "left-top",
            css: {
                alignItems: "flex-start",
                justifyContent: "flex-start"
            }
        },
        {
            direction: "vertical",
            alignment: "center-top",
            css: {
                alignItems: "center",
                justifyContent: "flex-start",
                textAlign: "center"
            }
        },
        {
            direction: "vertical",
            alignment: "right-top",
            css: {
                alignItems: "flex-end",
                justifyContent: "flex-start"
            }
        },
        {
            direction: "vertical",
            alignment: "left-center",
            css: {
                alignItems: "flex-start",
                justifyContent: "center"
            }
        },
        {
            direction: "vertical",
            alignment: "center-center",
            css: {
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center"
            }
        },
        {
            direction: "vertical",
            alignment: "right-center",
            css: {
                alignItems: "flex-end",
                justifyContent: "center"
            }
        },
        {
            direction: "vertical",
            alignment: "left-bottom",
            css: {
                alignItems: "flex-start",
                justifyContent: "flex-end"
            }
        },
        {
            direction: "vertical",
            alignment: "center-bottom",
            css: {
                alignItems: "center",
                justifyContent: "flex-end",
                textAlign: "center"
            }
        },
        {
            direction: "vertical",
            alignment: "right-bottom",
            css: {
                alignItems: "flex-end",
                justifyContent: "flex-end"
            }
        },
        {
            direction: "horizontal",
            alignment: "left-top",
            css: {
                justifyContent: "flex-start",
                alignItems: "flex-start"
            }
        },
        {
            direction: "horizontal",
            alignment: "center-top",
            css: {
                justifyContent: "center",
                alignItems: "flex-start",
                textAlign: "center"
            }
        },
        {
            direction: "horizontal",
            alignment: "right-top",
            css: {
                justifyContent: "flex-end",
                alignItems: "flex-start"
            }
        },
        {
            direction: "horizontal",
            alignment: "left-center",
            css: {
                justifyContent: "flex-start",
                alignItems: "center"
            }
        },
        {
            direction: "horizontal",
            alignment: "center-center",
            css: {
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center"
            }
        },
        {
            direction: "horizontal",
            alignment: "right-center",
            css: {
                justifyContent: "flex-end",
                alignItems: "center"
            }
        },
        {
            direction: "horizontal",
            alignment: "left-bottom",
            css: {
                justifyContent: "flex-start",
                alignItems: "flex-end"
            }
        },
        {
            direction: "horizontal",
            alignment: "center-bottom",
            css: {
                justifyContent: "center",
                alignItems: "flex-end",
                textAlign: "center"
            }
        },
        {
            direction: "horizontal",
            alignment: "right-bottom",
            css: {
                justifyContent: "flex-end",
                alignItems: "flex-end"
            }
        }, 
    ];
}

// EXTERNAL MODULE: ../../node_modules/@stitches/react/dist/index.mjs
var dist = __webpack_require__(43866);
;// CONCATENATED MODULE: ./src/components/content/modules/iframe/iframe.tsx


function Iframe(param) {
    var source = param.source, maxWidth = param.maxWidth, aspectRatio = param.aspectRatio;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        css: {
            maxWidth: Boolean(maxWidth) ? "".concat(maxWidth, "px") : "none"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Frame, {
            aspectRatio: aspectRatio,
            src: source
        })
    });
}
var Wrapper = (0,dist/* styled */.zo)("div", {
    display: "flex",
    justifyContent: "center",
    margin: "0 auto",
    width: "100%"
});
var Frame = (0,dist/* styled */.zo)("iframe", {
    border: 0,
    width: "100%",
    variants: {
        aspectRatio: {
            none: {
                aspectRatio: "auto"
            },
            video: {
                aspectRatio: "16 / 9"
            },
            document: {
                aspectRatio: "1 / 1.414"
            },
            fill: {
                height: "calc(100vh - $20)",
                maxWidth: "none"
            }
        }
    }
});

;// CONCATENATED MODULE: ./src/components/content/modules/utils.ts



function getBackgroundStyles(image, mobileImage, color) {
    var mainBgImage = (image === null || image === void 0 ? void 0 : image.url) ? "url(".concat((0,imageHelper/* resizeImage */.tg)(image.url, {
        width: 1800
    }), ")") : "none";
    var properties = {
        backgroundColor: color ? color : "transparent",
        backgroundImage: mainBgImage
    };
    // add mobile override
    if (mobileImage === null || mobileImage === void 0 ? void 0 : mobileImage.url) {
        properties = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, properties), {
            backgroundImage: "url(".concat((0,imageHelper/* resizeImage */.tg)(mobileImage.url, {
                width: 1800
            }), ")"),
            "@sm": {
                backgroundImage: mainBgImage
            }
        });
    }
    return properties;
}

;// CONCATENATED MODULE: ./src/components/content/modules/container.tsx










function container_Container(param) {
    var content = param.content, layout = param.layout;
    var ref;
    var hasImage = Boolean(layout === null || layout === void 0 ? void 0 : (ref = layout.backgroundImage) === null || ref === void 0 ? void 0 : ref.url);
    var ref1, ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(container_Wrapper, {
        className: "module-container--wrapper",
        css: (0,_object_spread/* default */.Z)({}, getBackgroundStyles(layout === null || layout === void 0 ? void 0 : layout.backgroundImage, layout === null || layout === void 0 ? void 0 : layout.mobileBackgroundImage, layout === null || layout === void 0 ? void 0 : layout.backgroundColor)),
        children: [
            hasImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(container_Overlay, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(container_Element, {
                hasImage: hasImage,
                alignment: (ref1 = layout === null || layout === void 0 ? void 0 : layout.alignment) !== null && ref1 !== void 0 ? ref1 : "center-center",
                direction: (ref2 = layout === null || layout === void 0 ? void 0 : layout.direction) !== null && ref2 !== void 0 ? ref2 : "vertical",
                children: content.order.map(function(id) {
                    var moduleItem = content.modules[id];
                    switch(moduleItem.type){
                        case Modules.container:
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(container_Container, (0,_object_spread/* default */.Z)({}, moduleItem), id);
                        case Modules.text:
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, (0,_object_spread/* default */.Z)({}, moduleItem), id);
                        case Modules.image:
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, (0,_object_spread/* default */.Z)({}, moduleItem), id);
                        case Modules.button:
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(button_Button, (0,_object_spread/* default */.Z)({}, moduleItem.button), id);
                        case Modules.iframe:
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Iframe, (0,_object_spread/* default */.Z)({}, moduleItem), id);
                        default:
                            return null;
                    }
                })
            })
        ]
    });
}
var container_Wrapper = (0,stitches/* styled */.zo)("section", {
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "grid"
});
var container_Overlay = (0,stitches/* styled */.zo)("div", {
    backgroundColor: "rgba(0, 0, 0, 0.3)",
    gridColumn: "1 / -1",
    gridRow: "1 / -1",
    zIndex: "$0"
});
var container_Element = (0,stitches/* styled */.zo)("div", {
    display: "flex",
    flexDirection: "column",
    gap: "$8",
    maxWidth: "$4xl",
    margin: "0 auto",
    padding: "$12",
    width: "100%",
    zIndex: "$10",
    variants: {
        hasImage: {
            true: {
                minHeight: "$128"
            }
        },
        direction: {
            horizontal: {
                flexDirection: "row"
            },
            vertical: {
                flexDirection: "column"
            }
        },
        // you need to define all variants here to use them, even though we use them in the compoundVariants returned from `getAlignmentVariants`
        alignment: {
            "left-top": {},
            "center-top": {},
            "right-top": {},
            "left-center": {},
            "center-center": {},
            "right-center": {},
            "left-bottom": {},
            "center-bottom": {},
            "right-bottom": {}
        }
    },
    "@maxsm": {
        padding: "$8"
    },
    compoundVariants: getAlignmentVariants()
});

;// CONCATENATED MODULE: ./src/components/content/modules/column.tsx



;// CONCATENATED MODULE: ./src/components/content/modules/columns.tsx





function Columns(param) {
    var content = param.content, layout = param.layout, _columns = param.columns, columns = _columns === void 0 ? "three" : _columns;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(columns_Wrapper, {
        css: (0,_object_spread/* default */.Z)({}, getBackgroundStyles(layout === null || layout === void 0 ? void 0 : layout.backgroundImage, layout === null || layout === void 0 ? void 0 : layout.mobileBackgroundImage, layout === null || layout === void 0 ? void 0 : layout.backgroundColor)),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(columns_Element, {
            columns: columns,
            children: content.order.map(function(id) {
                var moduleItem = content.modules[id];
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(container_Container, (0,_object_spread/* default */.Z)({}, moduleItem), id);
            })
        })
    });
}
var columns_Wrapper = (0,stitches/* styled */.zo)("section", {});
var columns_Element = (0,stitches/* styled */.zo)("div", {
    display: "grid",
    width: "100%",
    variants: {
        columns: {
            one: {
                gridTemplateColumns: "1fr"
            },
            two: {
                "@md": {
                    gridTemplateColumns: "repeat(2, 1fr)"
                }
            },
            three: {
                "@md": {
                    gridTemplateColumns: "repeat(3, 1fr)"
                }
            },
            four: {
                "@md": {
                    gridTemplateColumns: "repeat(2, 1fr)"
                },
                "@lg": {
                    gridTemplateColumns: "repeat(4, 1fr)"
                }
            }
        }
    }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../packages/sdk/dist/v4/index.mjs + 8 modules
var v4 = __webpack_require__(40024);
// EXTERNAL MODULE: ../../node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(63602);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(56580);
// EXTERNAL MODULE: ./src/components/ui/index.ts
var ui = __webpack_require__(56218);
// EXTERNAL MODULE: ./src/constants/states.ts
var states = __webpack_require__(49956);
// EXTERNAL MODULE: ./src/redux/locations/actions.ts
var actions = __webpack_require__(17464);
// EXTERNAL MODULE: ./src/redux/locations/reducer.ts
var reducer = __webpack_require__(3071);
// EXTERNAL MODULE: ./src/utils/global.ts
var global = __webpack_require__(36304);
// EXTERNAL MODULE: ./src/utils/locations.ts + 2 modules
var locations = __webpack_require__(52591);
// EXTERNAL MODULE: ./src/utils/magicBox.ts
var utils_magicBox = __webpack_require__(39916);
;// CONCATENATED MODULE: ./src/components/content/modules/form/locations.tsx














function Locations(param) {
    var label = param.label, name = param.name, required = param.required;
    var createOption = function createOption(item, index, mapping, refObject) {
        // The group of locations is uniquely identified by the state name.
        // @ts-ignore `state` string can't index `stateAbbrMappings`.
        var stateName = mapping[item];
        /** @ts-ignore `state` can't index `statesObject`. */ var locations = refObject[item].map(function(location) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                value: location.label,
                children: location.label
            }, location.id);
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("optgroup", {
            label: stateName,
            children: locations
        }, index);
    };
    var ref = (0,_sliced_to_array/* default */.Z)((0,formik_esm/* useField */.U$)({
        name: name,
        required: required
    }), 2), field = ref[0], meta = ref[1];
    var magicBox = new utils_magicBox/* MagicBoxParams */.t().setPagination(1, 100).setSorts({
        state_id: "asc",
        label: "asc"
    }).setIncludes([
        "label"
    ]);
    var list = (0,es.useSelector)(reducer/* locationsSliceSelector */.iz).list;
    var dispatch = (0,es.useDispatch)();
    // location organization
    var locationsByCountry = (0,locations/* splitLocationsByCountry */.I9)(list !== null && list !== void 0 ? list : []);
    // Group US locations by state and sort alphabetically.
    var ref1 = (0,global/* genericGroupItemsByKey */.sW)(locationsByCountry.US, "cached_data.state"), statesArray = ref1.filtersArray, statesObject = ref1.filtersObject;
    // Group CA locations by province and sort alphabetically.
    var ref2 = (0,global/* genericGroupItemsByKey */.sW)(locationsByCountry.CA, "cached_data.state"), provincesArray = ref2.filtersArray, provincesObject = ref2.filtersObject;
    (0,react.useEffect)(function() {
        dispatch(actions/* locationsActions.fetchAllLocations */.b.fetchAllLocations(magicBox));
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Form.Select */.l0.Select, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field), {
        label: label,
        name: name,
        required: required,
        error: meta.touched && meta.error ? meta.error : undefined,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                children: "— Select a location —"
            }),
            statesArray.map(function(item, index) {
                return createOption(item, index, states/* stateAbbrMappings */.S, statesObject);
            }),
            provincesArray.map(function(item, index) {
                return createOption(item, index, states/* canadianProvinceAbbrMappings */.E, provincesObject);
            })
        ]
    }));
}

;// CONCATENATED MODULE: ./src/components/content/modules/form/message.tsx






function Message(param) {
    var label = param.label, name = param.name, required = param.required;
    var ref = (0,_sliced_to_array/* default */.Z)((0,formik_esm/* useField */.U$)({
        name: name,
        required: required
    }), 2), field = ref[0], meta = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Form.Textarea */.l0.Textarea, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field), {
        name: name,
        label: label,
        required: required,
        error: meta.touched && meta.error ? meta.error : undefined
    }));
}

// EXTERNAL MODULE: ../../node_modules/yup/es/index.js + 26 modules
var yup_es = __webpack_require__(65413);
// EXTERNAL MODULE: ./src/constants/validation.ts
var validation = __webpack_require__(38885);
;// CONCATENATED MODULE: ./src/components/content/modules/form/text.tsx










var emailSchema = (0,yup_es/* object */.Ry)({
    value: (0,yup_es/* string */.Z_)().email()
});
var phoneSchema = (0,yup_es/* object */.Ry)({
    value: (0,yup_es/* string */.Z_)().matches(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/)
});
function Field(param) {
    var label = param.label, name = param.name, required = param.required, _type = param.type, type = _type === void 0 ? "text" : _type;
    var ref = (0,_sliced_to_array/* default */.Z)((0,formik_esm/* useField */.U$)({
        name: name,
        type: type,
        validate: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(value) {
                var isValid, isValid1;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (value === "") {
                                return [
                                    2
                                ];
                            }
                            if (!(type === "email")) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                emailSchema.isValid({
                                    value: value
                                })
                            ];
                        case 1:
                            isValid = _state.sent();
                            return [
                                2,
                                !isValid ? validation/* VALIDATION_STRINGS.EMAIL */.xz.EMAIL : undefined
                            ];
                        case 2:
                            if (!(type === "tel")) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                phoneSchema.isValid({
                                    value: value
                                })
                            ];
                        case 3:
                            isValid1 = _state.sent();
                            return [
                                2,
                                !isValid1 ? validation/* VALIDATION_STRINGS.PHONE */.xz.PHONE : undefined
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(value) {
                return _ref.apply(this, arguments);
            };
        }()
    }), 2), field = ref[0], meta = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Form.Input */.l0.Input, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field), {
        label: label,
        name: name,
        required: required,
        error: meta.touched && meta.error ? meta.error : undefined
    }));
}

// EXTERNAL MODULE: ./src/components/content/page.tsx
var page = __webpack_require__(79803);
// EXTERNAL MODULE: ./src/components/uielements/modal/index.tsx + 9 modules
var modal = __webpack_require__(84247);
// EXTERNAL MODULE: ./src/components/uielements/primaryButton/styles.tsx
var styles = __webpack_require__(25167);
// EXTERNAL MODULE: ./src/components/uielements/stack/stack.tsx + 2 modules
var stack = __webpack_require__(45866);
// EXTERNAL MODULE: ./src/redux/global/reducer.ts
var global_reducer = __webpack_require__(83626);
// EXTERNAL MODULE: ./src/services/client.ts + 1 modules
var services_client = __webpack_require__(44277);
// EXTERNAL MODULE: ./src/utils/index.ts
var src_utils = __webpack_require__(32210);
;// CONCATENATED MODULE: ./src/components/content/modules/form/form.tsx























function FormWrapper(param) {
    var id = param.id, content = param.content, title = param.title, description = param.description, label = param.label;
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)(false), success = ref1[0], setSuccess = ref1[1];
    var ref2 = (0,global_reducer/* useGlobalDispatch */.xP)(), dispatch = ref2.dispatch, displayErrorToast = ref2.displayErrorToast;
    var pageId = (0,react.useContext)(page/* PageContext */.z);
    var initialValues = {};
    content.order.forEach(function(id) {
        var field = content.modules[id];
        initialValues[field.name] = "";
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
        initialValues: initialValues,
        onSubmit: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(values, param) {
                var resetForm, client, e, errorMessage;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            resetForm = param.resetForm;
                            if (loading) {
                                return [
                                    2
                                ];
                            }
                            setLoading(true);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                5,
                                6
                            ]);
                            client = (0,services_client/* createHttpClient */.d9)({
                                origin: (0,src_utils/* getOrigin */.P$)(window.location.host)
                            });
                            return [
                                4,
                                (0,v4/* contact */.PX)((0,_object_spread/* default */.Z)({
                                    module_id: id,
                                    page_id: pageId
                                }, values), {
                                    client: client
                                })
                            ];
                        case 2:
                            _state.sent();
                            setSuccess(true);
                            resetForm();
                            return [
                                3,
                                6
                            ];
                        case 3:
                            e = _state.sent();
                            return [
                                4,
                                (0,global/* prepareErrorMessage */.Xr)("Something went wrong.", e)
                            ];
                        case 4:
                            errorMessage = _state.sent();
                            dispatch(displayErrorToast(errorMessage.message));
                            return [
                                3,
                                6
                            ];
                        case 5:
                            setLoading(false);
                            return [
                                7
                            ];
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(values, _) {
                return _ref.apply(this, arguments);
            };
        }(),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(form_Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText, {
                    value: title,
                    tag: Elements.heading
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText, {
                    value: description,
                    tag: Elements.paragraph
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(stack/* Stack */.K, {
                    overrides: {
                        marginTop: "var(--size-4)"
                    },
                    direction: "vertical",
                    align: "trailing",
                    gap: "var(--size-4)",
                    children: [
                        content.order.map(function(id) {
                            var moduleItem = content.modules[id];
                            switch(moduleItem.type){
                                case Modules.formText:
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Field, (0,_object_spread/* default */.Z)({}, moduleItem), id);
                                case Modules.formEmail:
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Field, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, moduleItem), {
                                        type: "email"
                                    }), id);
                                case Modules.formPhone:
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Field, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, moduleItem), {
                                        type: "tel"
                                    }), id);
                                case Modules.formMessage:
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Message, (0,_object_spread/* default */.Z)({}, moduleItem), id);
                                case Modules.formLocations:
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Locations, (0,_object_spread/* default */.Z)({}, moduleItem), id);
                                default:
                                    return null;
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledPrimaryButton */.D, {
                            type: "submit",
                            children: loading ? "Sending..." : label
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Container */.u.Container, {
                    requestVisibility: success,
                    onCancel: function() {
                        return setSuccess(false);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Title */.u.Title, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Content */.u.Content, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Thanks, your message has been sent!"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Footer */.u.Footer, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Cancel */.u.Cancel, {
                                    children: "Close"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
}
var form_Container = (0,stitches/* styled */.zo)(formik_esm/* Form */.l0, {
    margin: "0 auto",
    maxWidth: "100%",
    padding: "$4",
    width: "$2xl",
    "@md": {
        padding: "$12"
    }
});

;// CONCATENATED MODULE: ./src/components/content/modules/hero/hero.tsx







var Hero = function(param) {
    var layout = param.layout, content = param.content, cta = param.cta;
    var ref;
    var hasImage = Boolean(layout === null || layout === void 0 ? void 0 : (ref = layout.backgroundImage) === null || ref === void 0 ? void 0 : ref.url);
    var _url = cta.url, reference = _url.reference, buttonLabel = _url.label;
    var ref1, ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(hero_Container, {
        hasImage: hasImage,
        css: (0,_object_spread/* default */.Z)({}, getBackgroundStyles(layout === null || layout === void 0 ? void 0 : layout.backgroundImage, layout === null || layout === void 0 ? void 0 : layout.mobileBackgroundImage, layout === null || layout === void 0 ? void 0 : layout.backgroundColor)),
        children: [
            hasImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(hero_Overlay, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(hero_Element, {
                alignment: (ref1 = layout === null || layout === void 0 ? void 0 : layout.alignment) !== null && ref1 !== void 0 ? ref1 : "center-center",
                direction: (ref2 = layout === null || layout === void 0 ? void 0 : layout.direction) !== null && ref2 !== void 0 ? ref2 : "vertical",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText, {
                        value: content
                    }),
                    Boolean(reference === null || reference === void 0 ? void 0 : reference.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                        style: cta.style,
                        href: reference === null || reference === void 0 ? void 0 : reference.url,
                        newWindow: reference === null || reference === void 0 ? void 0 : reference.newWindow,
                        label: buttonLabel,
                        type: reference === null || reference === void 0 ? void 0 : reference.type
                    })
                ]
            })
        ]
    });
};
var hero_Container = (0,stitches/* styled */.zo)("div", {
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "grid",
    minHeight: "$128",
    // when a module has a background image, it's common for the text to be white
    // this can still be overridden by each text field and module's color value
    variants: {
        hasImage: {
            true: {
                color: "white"
            },
            false: {
                color: "inherit"
            }
        }
    }
});
var hero_Overlay = (0,stitches/* styled */.zo)("div", {
    backgroundColor: "rgba(0, 0, 0, 0.3)",
    gridColumn: "1 / -1",
    gridRow: "1 / -1",
    zIndex: "$0"
});
var hero_Element = (0,stitches/* styled */.zo)("div", {
    display: "flex",
    gridColumn: "1 / -1",
    gridRow: "1 / -1",
    height: "100%",
    padding: "$12",
    zIndex: "$10",
    variants: {
        direction: {
            horizontal: {
                flexDirection: "row"
            },
            vertical: {
                flexDirection: "column"
            }
        },
        // you need to define all variants here to use them, even though we use them in the compoundVariants returned from `getAlignmentVariants`
        alignment: {
            "left-top": {},
            "center-top": {},
            "right-top": {},
            "left-center": {},
            "center-center": {},
            "right-center": {},
            "left-bottom": {},
            "center-bottom": {},
            "right-bottom": {}
        }
    },
    compoundVariants: getAlignmentVariants()
});

;// CONCATENATED MODULE: ./src/components/content/modules/link-list/link.tsx


function Link(param) {
    var url = param.url, color = param.color, fontStyle = param.fontStyle;
    var reference = url.reference, label = url.label;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(link_Element, {
        css: {
            color: color !== null && color !== void 0 ? color : "inherit"
        },
        typography: fontStyle,
        href: (ref = reference === null || reference === void 0 ? void 0 : reference.url) !== null && ref !== void 0 ? ref : "#",
        target: (reference === null || reference === void 0 ? void 0 : reference.newWindow) ? "_blank" : "_self",
        children: label
    });
}
var link_Element = (0,stitches/* styled */.zo)("a", {
    variants: {
        typography: {
            primary: {
                fontFamily: "$primary",
                fontSize: "$primary"
            },
            secondary: {
                fontFamily: "$secondary",
                fontSize: "$secondary"
            }
        }
    },
    defaultVariants: {
        typography: "primary"
    }
});

;// CONCATENATED MODULE: ./src/components/content/modules/link-list/link-list.tsx




function LinkList(param) {
    var content = param.content;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(stack/* Stack */.K, {
        children: content.order.map(function(id) {
            var moduleItem = content.modules[id];
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, (0,_object_spread/* default */.Z)({}, moduleItem), id);
        })
    });
}

// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ./src/constants/routes.ts
var routes = __webpack_require__(25643);
// EXTERNAL MODULE: ./src/features/popular-items/service.tsx
var service = __webpack_require__(7987);
// EXTERNAL MODULE: ./src/features/popular-items/widget.tsx + 2 modules
var widget = __webpack_require__(18827);
// EXTERNAL MODULE: ./src/redux/index.ts
var redux = __webpack_require__(86879);
// EXTERNAL MODULE: ./src/services/recommendations.service.ts
var recommendations_service = __webpack_require__(20321);
;// CONCATENATED MODULE: ./src/components/content/modules/popular-items.tsx











function PopularItems(param) {
    var title = param.title;
    var ref;
    var router = (0,next_router.useRouter)();
    var flagship_store_location = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.cmsConfig.webConfig.menu;
    }).flagship_store_location;
    var font = (0,cmsConfig/* useConfigOverride */.$E)("menu_category_header").font;
    var ref1 = (0,service/* usePopularItems */.R)({
        location: flagship_store_location
    }), response = ref1.response, enabled = ref1.enabled, getItem = ref1.getItem, count = ref1.count;
    if (!enabled || response.status !== "success") {
        return null;
    }
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(popular_items_Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(widget/* Widget */.$, {
            count: count,
            items: (ref2 = (ref = response.data) === null || ref === void 0 ? void 0 : ref.products.map(getItem)) !== null && ref2 !== void 0 ? ref2 : [],
            onClick: function(item) {
                (0,recommendations_service/* setSelectedPopularItem */.w8)(item.id);
                void router.push(routes/* ROUTES.LOCATIONS */.Z6.LOCATIONS);
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                css: (0,_object_spread/* default */.Z)({}, (0,utils/* getFontStyles */.l)(font)),
                children: title
            })
        })
    });
}
var popular_items_Container = (0,stitches/* styled */.zo)("div", {
    margin: "0 auto",
    maxWidth: "$7xl",
    padding: "$6 $3",
    "@md": {
        padding: "$12"
    }
});
var Title = (0,stitches/* styled */.zo)("h2", {
    margin: 0
});

;// CONCATENATED MODULE: ./src/components/content/modules/slider/slide.tsx

// @TODO: hero, container, and slide are all similar (with container being more flexible)
// think through how all of these modules could use the same layout module to avoid duplicitive code


;// CONCATENATED MODULE: ./src/components/content/modules/slider/controls.tsx


function Play() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Play slider"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.8136 9.17794C13.3876 9.57562 13.3876 10.4242 12.8136 10.8219L8.06958 14.1087C7.40638 14.5682 6.50008 14.0935 6.50008 13.2867L6.50008 6.71315C6.50008 5.90633 7.40638 5.43168 8.06958 5.89116L12.8136 9.17794Z",
                fill: "white"
            })
        ]
    });
}
function Pause() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Pause slider"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9 7C9 6.44772 8.55228 6 8 6C7.44772 6 7 6.44772 7 7V13C7 13.5523 7.44772 14 8 14C8.55228 14 9 13.5523 9 13V7ZM13 7C13 6.44772 12.5523 6 12 6C11.4477 6 11 6.44772 11 7V13C11 13.5523 11.4477 14 12 14C12.5523 14 13 13.5523 13 13V7Z",
                fill: "white"
            })
        ]
    });
}
function Previous() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Previous slide"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6 9.99999L11.6194 4.94252C11.9273 4.66543 12.4015 4.69039 12.6786 4.99827C12.9557 5.30615 12.9307 5.78037 12.6229 6.05746L8.24227 9.99999L12.6229 13.9425C12.9307 14.2196 12.9557 14.6938 12.6786 15.0017C12.4015 15.3096 11.9273 15.3346 11.6194 15.0575L6 9.99999Z",
                fill: "white"
            })
        ]
    });
}
function Next() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Next slide"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.1211 10L8.50168 15.0575C8.1938 15.3346 7.71958 15.3096 7.44249 15.0017C7.16539 14.6938 7.19035 14.2196 7.49823 13.9425L11.8788 10L7.49824 6.05748C7.19035 5.78038 7.16539 5.30617 7.44249 4.99828C7.71958 4.6904 8.1938 4.66544 8.50168 4.94254L14.1211 10Z",
                fill: "white"
            })
        ]
    });
}
function Controls(param) {
    var active = param.active, items = param.items, showAutoPlayControls = param.showAutoPlayControls, isAutoPlaying = param.isAutoPlaying, onChange = param.onChange, onPlayStateChange = param.onPlayStateChange;
    var lastSlide = items.length - 1;
    var decrement = function() {
        var previous = active > 0 ? active - 1 : lastSlide;
        onChange(previous);
    };
    var increment = function() {
        var next = active < lastSlide ? active + 1 : 0;
        onChange(next);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Navigation, {
        children: [
            showAutoPlayControls && /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavigationItem, {
                css: {
                    marginRight: "$2"
                },
                onClick: function() {
                    return onPlayStateChange();
                },
                children: [
                    !isAutoPlaying && /*#__PURE__*/ (0,jsx_runtime.jsx)(Play, {}),
                    isAutoPlaying && /*#__PURE__*/ (0,jsx_runtime.jsx)(Pause, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItem, {
                onClick: decrement,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Previous, {})
            }),
            items.map(function(id, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavigationItem, {
                    onClick: function() {
                        return onChange(index);
                    },
                    children: [
                        index + 1,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Dot, {
                            active: active === index
                        })
                    ]
                }, id);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItem, {
                onClick: increment,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Next, {})
            })
        ]
    });
}
var Navigation = (0,stitches/* styled */.zo)("div", {
    alignItems: "center",
    bottom: "0",
    display: "flex",
    justifyContent: "center",
    padding: "$4",
    position: "absolute",
    left: "0",
    right: "0",
    zIndex: "$10"
});
var NavigationItem = (0,stitches/* styled */.zo)("button", {
    appearance: "none",
    backgroundColor: "transparent",
    border: "none",
    color: "transparent",
    cursor: "pointer",
    display: "grid",
    height: "$5",
    lineHeight: 0,
    gridTemplateColumns: "1fr",
    gridTemplateRows: "1fr",
    padding: 0,
    placeItems: "center",
    width: "$5",
    "& *": {
        gridColumn: "1 / -1",
        gridRow: "1 / -1"
    }
});
var Dot = (0,stitches/* styled */.zo)("span", {
    borderRadius: "100%",
    display: "block",
    height: "$2",
    gridColumn: "1 / -1",
    gridRow: "1 / -1",
    width: "$2",
    variants: {
        active: {
            true: {
                backgroundColor: "white"
            },
            false: {
                backgroundColor: "rgba(255,255,255,.5)"
            }
        }
    }
});

;// CONCATENATED MODULE: ./src/components/content/modules/slider/slider.tsx






function Slider(param) {
    var content = param.content, _autoplay = param.autoplay, autoplay = _autoplay === void 0 ? true : _autoplay, _interval = param.interval, interval = _interval === void 0 ? 5 : _interval;
    // @TODO: replace one-off slider functionality with the `useSlider` hook
    var ref = (0,react.useState)(0), active = ref[0], setActive = ref[1];
    var ref1 = (0,react.useState)(autoplay), shouldAutoplay = ref1[0], setShouldAutoplay = ref1[1];
    var timeout = Number(interval) * 1000;
    var timer;
    (0,react.useEffect)(function() {
        if (shouldAutoplay) {
            timer = setTimeout(function() {
                setActive(active === content.order.length - 1 ? 0 : active + 1);
            }, timeout);
            return function() {
                clearTimeout(timer);
            };
        } else {
            clearTimeout(timer);
        }
    }, [
        active,
        shouldAutoplay
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(slider_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Track, {
                children: content.order.map(function(id) {
                    var moduleItem = content.modules[id];
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                        css: {
                            transform: "translate3d(".concat(active * -100, "%, 0, 0)")
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero, (0,_object_spread/* default */.Z)({}, moduleItem), id)
                    }, id);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Controls, {
                active: active,
                items: content.order,
                showAutoPlayControls: autoplay,
                isAutoPlaying: shouldAutoplay,
                onChange: function(value) {
                    setActive(value);
                    setShouldAutoplay(false);
                },
                onPlayStateChange: function() {
                    return setShouldAutoplay(!shouldAutoplay);
                }
            })
        ]
    });
}
var slider_Wrapper = (0,stitches/* styled */.zo)("section", {
    position: "relative"
});
var Track = (0,stitches/* styled */.zo)("div", {
    display: "flex",
    overflow: "hidden"
});
var Item = (0,stitches/* styled */.zo)("div", {
    flex: "none",
    transition: "all .4s ease",
    width: "100%",
    zIndex: "$0"
});

;// CONCATENATED MODULE: ./src/components/content/modules/index.tsx

















var Form = {
    Wrapper: FormWrapper,
    Field: Field,
    Message: Message,
    Locations: Locations
};


;// CONCATENATED MODULE: ./src/components/content/utils.tsx





function contentGetModule(id, module) {
    switch(module.type){
        case Modules.button:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(button_Button, (0,_object_spread/* default */.Z)({}, module.button), id);
        case Modules.column:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(container_Container, (0,_object_spread/* default */.Z)({}, module), id);
        case Modules.columns:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Columns, (0,_object_spread/* default */.Z)({}, module), id);
        case Modules.container:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(container_Container, (0,_object_spread/* default */.Z)({}, module), id);
        case Modules.form:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form.Wrapper, (0,_object_spread/* default */.Z)({
                id: id
            }, module), id);
        case Modules.formText:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form.Field, (0,_object_spread/* default */.Z)({}, module), id);
        case Modules.formMessage:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form.Message, (0,_object_spread/* default */.Z)({}, module), id);
        case Modules.formEmail:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form.Field, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, module), {
                type: "email"
            }), id);
        case Modules.formPhone:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form.Field, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, module), {
                type: "tel"
            }), id);
        case Modules.formLocations:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form.Locations, (0,_object_spread/* default */.Z)({}, module), id);
        case Modules.hero:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero, (0,_object_spread/* default */.Z)({}, module), id);
        case Modules.iframe:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Iframe, (0,_object_spread/* default */.Z)({}, module), id);
        case Modules.image:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, (0,_object_spread/* default */.Z)({}, module), id);
        case Modules.linkList:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkList, (0,_object_spread/* default */.Z)({}, module), id);
        case Modules.link:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, (0,_object_spread/* default */.Z)({}, module), id);
        case Modules.popularItems:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PopularItems, (0,_object_spread/* default */.Z)({}, module), id);
        case Modules.slider:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider, (0,_object_spread/* default */.Z)({}, module), id);
        case Modules.slide:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero, (0,_object_spread/* default */.Z)({}, module), id);
        case Modules.text:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, (0,_object_spread/* default */.Z)({}, module), id);
        default:
            return null;
    }
}

;// CONCATENATED MODULE: ./src/components/content/content.tsx




function Content(param) {
    var content = param.content, _enablePreviewerTools = param.enablePreviewerTools, enablePreviewerTools = _enablePreviewerTools === void 0 ? false : _enablePreviewerTools, highlighedModule = param.highlighedModule;
    if (!(content === null || content === void 0 ? void 0 : content.order)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(content_Container, {
        children: content.order.map(function(id) {
            var currentModule = content === null || content === void 0 ? void 0 : content.modules[id];
            if (enablePreviewerTools) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Preview, {
                    id: id,
                    isHighlighted: highlighedModule === id,
                    children: contentGetModule(id, currentModule)
                });
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: contentGetModule(id, currentModule)
            });
        })
    });
}
var content_Container = (0,stitches/* styled */.zo)("div", {
    position: "relative",
    zIndex: "$0"
});


/***/ }),

/***/ 79803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ Page; },
/* harmony export */   "z": function() { return /* binding */ PageContext; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _components_app_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37356);
/* harmony import */ var _components_content_content__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87082);





var PageContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.createContext)("");
function Page(param) {
    var id = param.id, content = param.content, seoTitle = param.seoTitle, seoDescription = param.seoDescription, seoImage = param.seoImage;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    seoTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                                children: seoTitle
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:title",
                                content: seoTitle
                            }, "og:title"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                name: "twitter:title",
                                content: seoTitle
                            }, "twitter:title")
                        ]
                    }),
                    seoDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                name: "description",
                                content: seoDescription
                            }, "description"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:description",
                                content: seoDescription
                            }, "og:description"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                name: "twitter:description",
                                content: seoDescription
                            }, "twitter:description")
                        ]
                    }),
                    seoImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:image",
                                content: seoImage
                            }, "og:image"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                name: "twitter:image",
                                content: seoImage
                            }, "twitter:image")
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_app_layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PageContext.Provider, {
                    value: id,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_content_content__WEBPACK_IMPORTED_MODULE_4__/* .Content */ .V, {
                        content: content
                    })
                })
            })
        ]
    });
}


/***/ }),

/***/ 7987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ usePopularItems; }
/* harmony export */ });
/* harmony import */ var _koala_sdk_v4__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40024);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47661);
/* harmony import */ var _redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86879);
/* harmony import */ var _services_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44277);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32210);
/* harmony import */ var _utils_menu__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(682);






/**
 * An api segment hook for fetching popular items for a specified location
 * ```
 * const { response, count, title, getProduct } = usePopularItems({ location: 1 });
 * ```
 */ function usePopularItems(param) {
    var location = param.location, wantedAt = param.wantedAt, _maxItems = param.maxItems, maxItems = _maxItems === void 0 ? 15 : _maxItems;
    var ref, ref1;
    var ref2 = (0,_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return state.app.cmsConfig.webConfig.menu;
    }), showPopularItems = ref2.popular_products;
    var ref3 = (0,_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return state.app.cmsConfig.strings.store;
    }), popularItemsHeader = ref3.popular_products_header;
    /**
   * Make sure that `usePopularItems` is prefetched before
   * this component renders, otherwise it will explode!
   * @see __DANGEROUS_EMPTY_REQUEST_ORIGIN
   */ var origin;
    if (true) {
        origin = (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .getOrigin */ .P$)(window.location.host);
    } else {}
    var response = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_5__/* .useQuery */ .a)({
        queryKey: [
            "popular-items",
            {
                id: location !== null && location !== void 0 ? location : 0,
                wantedAt: wantedAt !== null && wantedAt !== void 0 ? wantedAt : "asap"
            }, 
        ],
        queryFn: function() {
            return (0,_koala_sdk_v4__WEBPACK_IMPORTED_MODULE_0__/* .getPopularProducts */ .ji)({
                locationId: location !== null && location !== void 0 ? location : 0,
                maxItems: maxItems,
                wantedAt: wantedAt
            }, {
                client: (0,_services_client__WEBPACK_IMPORTED_MODULE_2__/* .createHttpClient */ .d9)({
                    origin: origin
                })
            });
        },
        enabled: showPopularItems && location !== null,
        refetchOnWindowFocus: false,
        staleTime: Infinity,
        keepPreviousData: true
    });
    var ref4;
    return {
        response: response,
        count: (ref4 = response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : (ref1 = ref.products) === null || ref1 === void 0 ? void 0 : ref1.length) !== null && ref4 !== void 0 ? ref4 : 0,
        title: popularItemsHeader,
        enabled: showPopularItems,
        getItem: function getItem(product) {
            // popular products return a product array of 1 product
            return (0,_utils_menu__WEBPACK_IMPORTED_MODULE_4__/* .augmentMenuProduct */ .P_)(product.products[0]);
        }
    };
}


/***/ }),

/***/ 18827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ Widget; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ./src/components/content/stitches.ts
var stitches = __webpack_require__(65465);
// EXTERNAL MODULE: ./src/components/ui/index.ts
var ui = __webpack_require__(56218);
// EXTERNAL MODULE: ./src/components/uielements/render.tsx
var render = __webpack_require__(45190);
// EXTERNAL MODULE: ./src/redux/cmsConfig/index.ts
var cmsConfig = __webpack_require__(26738);
// EXTERNAL MODULE: ./src/redux/cmsConfig/utils.ts
var utils = __webpack_require__(73393);
;// CONCATENATED MODULE: ./src/features/popular-items/card.tsx







function Card(param) {
    var image = param.image, name = param.name, description = param.description, calories = param.calories, price = param.price, onClick = param.onClick;
    var ref = (0,cmsConfig/* useConfigOverride */.$E)("global"), primary_border_color = ref.primary_border_color, border_radius = ref.border_radius;
    var primary_font = (0,cmsConfig/* useConfigOverride */.$E)("text").primary_font;
    var color = (0,utils/* getFontStyles */.l)(primary_font).color;
    var ref1 = (0,cmsConfig/* useConfigOverride */.$E)("menu_product_card"), hide_calories = ref1.hide_calories, hide_price = ref1.hide_price, hide_description = ref1.hide_description, hide_description_mobile = ref1.hide_description_mobile, hide_image = ref1.hide_image;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        onClick: onClick,
        direction: "vertical",
        css: {
            border: "1px solid ".concat(primary_border_color),
            borderRadius: "".concat(border_radius, "px"),
            color: color
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(render/* Render */.H, {
                condition: !hide_image,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContainer, {
                    children: image && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                        src: image,
                        alt: name
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                css: {
                    flex: "1 0 0",
                    fontSize: "$text200",
                    padding: "$3 $2 $6"
                },
                direction: "vertical",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(render/* Render */.H, {
                        condition: !hide_description,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                            hideOnMobile: hide_description_mobile,
                            children: description
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Stack */.Kq, {
                        css: {
                            gap: 0,
                            marginTop: "auto",
                            flexDirection: "column",
                            "@sm": {
                                flexDirection: "row",
                                gap: "$2"
                            }
                        },
                        position: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(render/* Render */.H, {
                                condition: !hide_price,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: price
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(render/* Render */.H, {
                                condition: !hide_calories,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: calories
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var ImageContainer = (0,stitches/* styled */.zo)("div", {
    aspectRatio: "1 / 1",
    backgroundColor: "$shade200",
    overflow: "hidden",
    transition: "all .4s ease",
    width: "100%"
});
var Image = (0,stitches/* styled */.zo)("img", {
    display: "block",
    height: "100%",
    objectFit: "cover",
    transition: "all .4s ease",
    width: "100%",
    maxWidth: 300
});
var Content = (0,stitches/* styled */.zo)(ui/* Stack */.Kq, {
    transition: "all .2s ease"
});
var Title = (0,stitches/* styled */.zo)("h3", {
    fontSize: "1rem",
    margin: 0
});
var Description = (0,stitches/* styled */.zo)("p", {
    margin: 0,
    variants: {
        hideOnMobile: {
            false: {
                display: "block"
            },
            true: {
                display: "none",
                "@md": {
                    display: "block"
                }
            }
        }
    }
});
var _obj;
var Container = (0,stitches/* styled */.zo)(ui/* Stack */.Kq, (_obj = {
    cursor: "pointer",
    height: "100%",
    overflow: "hidden",
    textAlign: "center",
    transition: "all .4s ease",
    transform: "translate3d(0,0,0)"
}, (0,_define_property/* default */.Z)(_obj, "&:hover ".concat(Image), {
    transform: "scale(1.1)"
}), (0,_define_property/* default */.Z)(_obj, "&:hover ".concat(ImageContainer), {
    backgroundColor: "$shade300"
}), _obj));

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./src/components/ui/use-slider/use-slider.tsx

/**
 * Encapsulates generic slider functionality used in various components
 * The goal of this hook is to handle basic slider requirements while not
 * dictating the UI.
 *
 * At the basic level, the [*]Prop objects (including dots) are all thats required to use this hook
 *
 * ```
 * const { backProps, nextProps, itemProps, dots } = useSlider({count: 12, perPage: 5});
 * ```
 * @param {Props} props.count the total number of items
 * @param {Props} props.perPage the number of items to show per page (slide)
 */ function useSlider(param) {
    var count = param.count, _perPage = param.perPage, perPage = _perPage === void 0 ? 1 : _perPage;
    var goBack = function goBack() {
        setPage(function(state) {
            if (disablePrevious) {
                return state;
            }
            // return state > 0 ? state - 1 : 0;
            return state - 1;
        });
    };
    var goForward = function goForward() {
        setPage(function(state) {
            if (disableNext) {
                return state;
            }
            return state + 1;
        });
    };
    var ref = (0,react.useState)(0), page = ref[0], setPage = ref[1];
    var ref1 = (0,react.useState)(true), disablePrevious = ref1[0], setDisablePrevious = ref1[1];
    var ref2 = (0,react.useState)(true), disableNext = ref2[0], setDisableNext = ref2[1];
    var ref3 = (0,react.useState)(0), offset = ref3[0], setOffset = ref3[1];
    var ref4 = (0,react.useState)(Math.ceil(count / perPage)), pages = ref4[0], setPages = ref4[1];
    (0,react.useEffect)(function() {
        var isFirstPage = page === 0;
        var isLastPage = page === pages - 1;
        setDisablePrevious(isFirstPage ? true : false);
        setDisableNext(isLastPage ? true : false);
        if (count <= perPage) {
            return;
        }
        if (isLastPage && count % perPage !== 0) {
            /*
       * This hook allows us to show multiple items per page.
       * For example, 15 total items with 5 per page will have 3 pages
       *
       * However, if there is a remainder (ie: 12 total items with 5 per page),
       * we don't want to show a gap on the last page the end.
       *
       * This check uses the `%` modulo operator to grab the difference (12%5 = 2)
       * and calculate the correct final offset
       *
       * Note: this doesn't work when we have a remainder of 0,
       * hence the if condition above to exclude even sets.
       *
       */ setOffset((page * perPage - (perPage - count % perPage)) * -100);
        } else {
            setOffset(page * perPage * -100); // each item is treated individually, so we offset the full value
        }
    }, [
        page,
        count,
        perPage,
        pages
    ]);
    (0,react.useEffect)(function() {
        setPages(Math.ceil(count / perPage));
    }, [
        count,
        perPage
    ]);
    return {
        // spread over the button that controls going back a page
        backProps: {
            onClick: goBack,
            disabled: disablePrevious
        },
        // spread over the button that controls going forward a page
        nextProps: {
            onClick: goForward,
            disabled: disableNext
        },
        // spread over each item, all items should be in a straight list
        // with the appropriate css applied based on the requirements
        // see: popular products widget as an example
        itemProps: {
            style: {
                transform: "translateX(".concat(offset, "%)")
            }
        },
        // map over and spread props to each dot button. Apply the label as the button label
        dots: Array.from(Array(pages).keys()).map(function(item) {
            return {
                label: item + 1,
                props: {
                    onClick: function() {
                        return setPage(item);
                    },
                    active: Boolean(page === item)
                }
            };
        }),
        // exposed low level operations for unique situations
        pages: pages,
        page: page,
        setPage: setPage
    };
}

// EXTERNAL MODULE: ./src/components/uielements/icon/index.tsx + 20 modules
var icon = __webpack_require__(98414);
// EXTERNAL MODULE: ./src/utils/imageHelper.ts
var imageHelper = __webpack_require__(70595);
;// CONCATENATED MODULE: ./src/features/popular-items/widget.tsx










function Widget(param) {
    var children = param.children, items = param.items, count = param.count, onClick = param.onClick;
    /*
   * The slider hook can be configured with:
   * - an item count
   * - a per page value (useful for complex sliders with multiple items in one slide, defaults to 1)
   */ var ref = useSlider({
        count: count,
        perPage: 5
    }), backProps = ref.backProps, nextProps = ref.nextProps, itemProps = ref.itemProps, dots = ref.dots;
    if (!items.length) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(widget_Container, {
        "data-testid": "popular-items-widget",
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(render/* Render */.H, {
                condition: count > 5,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Box */.xu, {
                    "data-testid": "popular-items-widget-controls",
                    css: {
                        display: "none",
                        "@lg": {
                            display: "block"
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Stack */.Kq, {
                        align: "center",
                        position: "trailing",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderNav, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, backProps), {
                                css: {
                                    transform: "rotate(180deg)"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default.Caret */.Z.Caret, {
                                    title: "previous"
                                })
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderNav, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, nextProps), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default.Caret */.Z.Caret, {
                                    title: "next"
                                })
                            }))
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Box */.xu, {
                css: {
                    margin: "0 -$3",
                    "@md": {
                        margin: "0 -$8"
                    },
                    "@lg": {
                        margin: "0 -$3"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Stack */.Kq, {
                    align: "fill",
                    gap: "0",
                    css: {
                        overflow: "scroll",
                        padding: "$7 0 0",
                        scrollSnapType: "x mandatory",
                        scrollbarWidth: "none",
                        "-ms-overflow-style": "none",
                        "&::-webkit-scrollbar": {
                            "-webkit-appearance": "none",
                            display: "none",
                            height: 0,
                            width: 0
                        },
                        "@lg": {
                            justifyContent: count > 5 ? "flex-start" : "center",
                            overflow: "hidden"
                        }
                    },
                    children: [
                        items.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardWrapper, {
                                "data-testid": "popular-items-widget-card",
                                css: {
                                    transition: "transform 0.6s ease",
                                    "@lg": (0,_object_spread/* default */.Z)({}, itemProps.style)
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card, {
                                    image: (0,imageHelper/* getProductImageSrc */.Wr)(item, {
                                        width: 300
                                    }),
                                    name: item.name,
                                    description: item.description,
                                    calories: item.pretty_calories,
                                    price: item.pretty_price,
                                    onClick: function() {
                                        return onClick(item, index);
                                    }
                                })
                            }, item.id);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardWrapper, {
                            css: {
                                width: "$1",
                                "@lg": {
                                    display: "none"
                                }
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(render/* Render */.H, {
                condition: count > 5,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Box */.xu, {
                    css: {
                        display: "none",
                        "@lg": {
                            display: "block"
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Stack */.Kq, {
                        position: "center",
                        gap: "$6",
                        css: {
                            padding: "$8 0 0",
                            "@lg": {
                                padding: "$12 0 0"
                            }
                        },
                        children: dots.map(function(dot, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderDot, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dot.props), {
                                children: dot.label
                            }), index);
                        })
                    })
                })
            })
        ]
    });
}
var widget_Container = (0,stitches/* styled */.zo)("div", {
    textAlign: "center"
});
var CardWrapper = (0,stitches/* styled */.zo)("div", {
    flex: "none",
    padding: "0 0 0 $2",
    scrollSnapAlign: "start",
    width: "40%",
    "@sm": {
        padding: "0 0 0 $4",
        width: "30%"
    },
    "@lg": {
        padding: "0 $3",
        width: "20%"
    }
});
var SliderNav = (0,stitches/* styled */.zo)("button", {
    all: "unset",
    borderRadius: "$sm",
    cursor: "pointer",
    svg: {
        display: "block"
    },
    "&:focus": {
        backgroundColor: "rgba(0,0,0,.08)"
    },
    variants: {
        disabled: {
            true: {
                cursor: "default",
                opacity: 0.2
            }
        }
    }
});
var SliderDot = (0,stitches/* styled */.zo)("button", {
    all: "unset",
    backgroundColor: "$accentPrimary",
    borderRadius: "100%",
    color: "$accentPrimary",
    height: "$3",
    opacity: 0.1,
    overflow: "hidden",
    transition: "all .2s ease",
    width: "$3",
    variants: {
        active: {
            true: {
                opacity: 1,
                "&:hover, &:focus": {
                    opacity: 1
                }
            }
        }
    },
    "&:hover": {
        opacity: 0.5
    },
    "&:focus": {
        boxShadow: "0 0 0 2px white, 0 0 0 4px currentColor",
        opacity: 0.5
    },
    "@lg": {
        cursor: "pointer"
    }
});


/***/ })

}]);